export interface UserTagsV2Payload {
  child_tags: number[];
  name: string;
  parent_tags: number[];
  tag_type_id: number;
}

export interface UserTagsV2Response {
  child_tags: number[];
  clients: string[];
  id: number | null;
  name: string;
  parent_tags: number[];
  tag_type: string;
  data?: { [key: string]: any };
}

export interface TagTypeTagV2 {
  id: number;
  name: string;
}

export enum TAG_TYPE_NAME {
  PROVIDER = "provider",
  REGION = "region",
  CBSA = "cbsa",
  CONFIDENTIALITY_LEVEL = "confidentiality_level",
  MARKET = "market",
}

export enum TAGS_TYPE_V2_ID {
  PROVIDER_ID = 4,
}

export interface TagsHierarchyV2ChildTags {
  id: number;
  name: string;
  tag_type: string;
  child_tags: {
    child_tags: any;
    id: number;
    name: string;
    tag_type: string;
  }[];
}

export interface TagsHierarchyV2 {
  id: number;
  name: string;
  tag_type: string;
  child_tags: TagsHierarchyV2ChildTags[];
}
